import React from 'react';

const NotFound = () => {
  return (
    <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
      <h1 style={{marginTop: "50px"}}>Ops! Página no encontrada</h1>
      <img style={{ margin: "35px auto"}} src='../../../404-error.png' alt="Error 404" width="350" />
    </div>
  );
};

export default NotFound;